//action synchrone ( Set )
// ex
export const updateValue = (state: any, payload: Number) => {
  state.value = payload;
};
